"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.qqDelaycallback = exports.qqDelay = exports.hsaDelay = void 0;
/**
 * 是否需要延迟行情的逻辑判断
 */
var cookie = require("../cookie");
/**
 * 沪深A行情是否需要延时
 * 除了登录的海外机构用户都不需要延时行情
 */
function hsaDelay() {
    var islogin = cookie.get('ut') != null;
    if (islogin && cookie.get('mtp') == '2' && cookie.get('wbp2uorgt') == '2')
        return true;
    return false;
}
exports.hsaDelay = hsaDelay;
/**
 * 期权行情是否需要屏蔽
 * 非登录的ip为海外的用户需要屏蔽
 * 登录的国外手机号用户需要屏蔽
 */
function qqDelay() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var islogin = cookie.get('ut') != null;
                    if (!islogin) {
                        //未知手机号归属 通过ip判断
                        if (cookie.get('dataip_lt') == "1") {
                            resolve(0);
                        }
                        else if (cookie.get('dataip_lt') == "1") {
                            resolve(1);
                        }
                        else {
                            $.ajax({
                                url: 'https://push2.eastmoney.com/api/qt/stock/get',
                                dataType: "jsonp",
                                jsonp: 'cb'
                            }).then(function (json) {
                                if (json && json.lt && json.lt == 2) { //海外
                                    cookie.set("dataip_lt", json.lt);
                                    resolve(1);
                                }
                                else {
                                    cookie.set("dataip_lt", "1");
                                    resolve(0);
                                }
                            });
                        }
                    }
                    else {
                        var cookie_mtp = cookie.get('mtp');
                        if (cookie_mtp == '1') { //国内手机号 
                            resolve(0);
                        }
                        else if (cookie_mtp == '2') { //国外手机号
                            resolve(1);
                        }
                    }
                })];
        });
    });
}
exports.qqDelay = qqDelay;
function qqDelaycallback(callback) {
    var islogin = cookie.get('ut') != null;
    if (!islogin) {
        //未知手机号归属 通过ip判断
        $.ajax({
            url: 'https://push2.eastmoney.com/api/qt/stock/get',
            dataType: "jsonp",
            jsonp: 'cb'
        }).then(function (json) {
            if (json && json.lt && json.lt == 2) { //海外
                callback(0);
            }
            else {
                callback(1);
            }
        });
    }
    else {
        var cookie_mtp = cookie.get('mtp');
        if (cookie_mtp == '1') { //国内手机号 
            callback(0);
        }
        else if (cookie_mtp == '2') { //国外手机号
            callback(1);
        }
    }
}
exports.qqDelaycallback = qqDelaycallback;
